<template>
    <div v-if="project">
        <v-row no-gutters>
            <v-col cols="4" sm="3" md="3" lg="2" xl="2" class="d-flex">
                <p class="mr-2 text-h6 text-bold">Name:</p>
            </v-col>
            <v-col
                cols="8"
                sm="9"
                md="9"
                lg="10"
                xl="10"
                class="d-flex  flex-wrap"
            >
                <p
                    :style="{
                        'margin-top': '5px',
                        'font-size': 'large',
                        'font-weight': '500',
                    }"
                >
                    {{ project.name }}
                </p>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="4" sm="3" md="3" lg="2" xl="2" class="d-flex">
                <p class="mr-2 text-h6 text-bold">Client:</p>
            </v-col>
            <v-col
                cols="8"
                sm="9"
                md="9"
                lg="10"
                xl="10"
                class="d-flex  flex-wrap"
            >
                <template>
                    <v-card flat>
                        <div class="d-flex my-1" :style="{ cursor: 'pointer' }">
                            <v-avatar
                                size="34"
                                color="grey lighten-4"
                                class="mr-1 ml-1"
                            >
                                <v-img v-if="clientImage" :src="clientImage" />
                                <span v-else class="text-h6">
                                    {{
                                        getClientName(project.client)
                                            .split(' ')
                                            .map((n, i, a) =>
                                                i === 0 || i + 1 === a.length
                                                    ? n[0]
                                                    : null
                                            )
                                            .join('')
                                            .toUpperCase()
                                    }}
                                </span>
                            </v-avatar>
                            <div
                                class="d-flex flex-column justify-space-around me-4"
                            >
                                <span class="font-weight-bold text-singleline">
                                    {{ getClientName(project.client) }}
                                </span>
                            </div>
                        </div>
                    </v-card>
                </template>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="4" sm="3" md="3" lg="2" xl="2" class="d-flex">
                <p class="mr-2 text-h6 text-bold">Account Manager:</p>
            </v-col>
            <v-col
                cols="8"
                sm="9"
                md="9"
                lg="10"
                xl="10"
                class="d-flex  flex-wrap"
            >
                <template>
                    <v-card flat>
                        <div class="d-flex my-1" :style="{ cursor: 'pointer' }">
                            <v-avatar
                                size="34"
                                color="grey lighten-4"
                                class="mr-1 ml-1"
                            >
                                <v-img
                                    v-if="accountManagerImage"
                                    :src="accountManagerImage"
                                />
                                <span v-else class="text-h6">
                                    {{
                                        getUserName(project.accountManager)
                                            .split(' ')
                                            .map((n, i, a) =>
                                                i === 0 || i + 1 === a.length
                                                    ? n[0]
                                                    : null
                                            )
                                            .join('')
                                            .toUpperCase()
                                    }}
                                </span>
                            </v-avatar>
                            <div
                                class="d-flex flex-column justify-space-around me-4"
                            >
                                <span class="font-weight-bold text-singleline">
                                    {{ getUserName(project.accountManager) }}
                                </span>
                            </div>
                        </div>
                    </v-card>
                </template>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="4" sm="3" md="3" lg="2" xl="2" class="d-flex">
                <p class="mr-2 text-h6 text-bold">Project Manager:</p>
            </v-col>
            <v-col
                cols="8"
                sm="9"
                md="9"
                lg="10"
                xl="10"
                class="d-flex  flex-wrap"
            >
                <template>
                    <v-card flat>
                        <div class="d-flex my-1" :style="{ cursor: 'pointer' }">
                            <v-avatar
                                size="34"
                                color="grey lighten-4"
                                class="mr-1 ml-1"
                            >
                                <v-img
                                    v-if="projectManagerImage"
                                    :src="projectManagerImage"
                                />
                                <span v-else class="text-h6">
                                    {{
                                        getUserName(project.projectManager)
                                            .split(' ')
                                            .map((n, i, a) =>
                                                i === 0 || i + 1 === a.length
                                                    ? n[0]
                                                    : null
                                            )
                                            .join('')
                                            .toUpperCase()
                                    }}
                                </span>
                            </v-avatar>
                            <div
                                class="d-flex flex-column justify-space-around me-4"
                            >
                                <span class="font-weight-bold text-singleline">
                                    {{ getUserName(project.projectManager) }}
                                </span>
                            </div>
                        </div>
                    </v-card>
                </template>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="4" sm="3" md="3" lg="2" xl="2" class="d-flex">
                <p class="mr-2 text-h6 text-bold">Purchase Approvers:</p>
            </v-col>
            <v-col
                cols="8"
                sm="9"
                md="9"
                lg="10"
                xl="10"
                class="d-flex flex-wrap"
            >
                <template>
                    <v-card
                        flat
                        v-for="(approver, index) in purchaseApproversList"
                        class="d-flex my-1"
                        :style="{
                            cursor: assignPurchaseApproverPermission
                                ? 'pointer'
                                : 'default',
                        }"
                        :key="index"
                        @click="openEditApproverDialog(approver)"
                    >
                        <v-avatar
                            size="34"
                            color="grey lighten-4"
                            class="mr-1 ml-1"
                        >
                            <v-img
                                v-if="approver.image"
                                :src="approver.image"
                            />
                            <span v-else class="text-h6">
                                {{
                                    approver.name
                                        .split(' ')
                                        .map((n, i, a) =>
                                            i === 0 || i + 1 === a.length
                                                ? n[0]
                                                : null
                                        )
                                        .join('')
                                        .toUpperCase()
                                }}
                            </span>
                        </v-avatar>
                        <div
                            class="d-flex flex-column justify-space-around me-4"
                        >
                            <span class="font-weight-bold text-singleline">
                                {{ approver.name }}
                            </span>
                            <span class="text-caption text-singleline">
                                {{
                                    formatCurrency(
                                        project.currency,
                                        approver.limit,
                                        2
                                    )
                                }}
                            </span>
                        </div>
                    </v-card>
                    <v-btn
                        v-if="assignPurchaseApproverPermission"
                        @click="assignApprover = true"
                        depressed
                        fab
                        x-small
                        color="primary"
                        class="mt-1"
                    >
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                </template>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="4" sm="3" md="3" lg="2" xl="2" class="d-flex">
                <p class="mr-2 text-h6 text-bold">Collaborators:</p>
            </v-col>
            <v-col
                cols="8"
                sm="9"
                md="9"
                lg="10"
                xl="10"
                class="d-flex  flex-wrap"
            >
                <template>
                    <v-card flat>
                        <div
                            class="d-flex my-1"
                            :style="{ cursor: 'pointer' }"
                            v-for="(collaborator, index) in filterDataColab"
                            :key="index"
                        >
                            <v-avatar
                                size="34"
                                color="grey lighten-4"
                                class="mr-1 ml-1"
                            >
                                <v-img
                                    v-if="collaborator && collaborator.picture"
                                    :src="collaborator.picture"
                                />
                                <span v-else class="text-h6">
                                    {{
                                        collaborator.name
                                            .split(' ')
                                            .map((n, i, a) =>
                                                i === 0 || i + 1 === a.length
                                                    ? n[0]
                                                    : null
                                            )
                                            .join('')
                                            .toUpperCase()
                                    }}
                                </span>
                            </v-avatar>
                            <div
                                class="d-flex flex-column justify-space-around me-4"
                            >
                                <span class="font-weight-bold text-singleline">
                                    {{ collaborator.name }}
                                </span>
                            </div>
                        </div>
                    </v-card>
                </template>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="4" sm="3" md="3" lg="2" xl="2" class="d-flex">
                <p class="mr-2 text-h6 text-bold">Design Managers:</p>
            </v-col>
            <v-col
                cols="8"
                sm="9"
                md="9"
                lg="10"
                xl="10"
                class="d-flex  flex-wrap"
            >
                <template>
                    <v-card flat>
                        <div
                            class="d-flex my-1"
                            :style="{ cursor: 'pointer' }"
                            v-for="(designManager, index) in filterDataDesignManagers"
                            :key="'dm-' + index"
                        >
                            <v-avatar
                                size="34"
                                color="grey lighten-4"
                                class="mr-1 ml-1"
                            >
                                <v-img
                                    v-if="designManager && designManager.picture"
                                    :src="designManager.picture"
                                />
                                <span v-else class="text-h6">
                                    {{
                                        designManager.name
                                            .split(' ')
                                            .map((n, i, a) =>
                                                i === 0 || i + 1 === a.length
                                                    ? n[0]
                                                    : null
                                            )
                                            .join('')
                                            .toUpperCase()
                                    }}
                                </span>
                            </v-avatar>
                            <div
                                class="d-flex flex-column justify-space-around me-4"
                            >
                                <span class="font-weight-bold text-singleline">
                                    {{ designManager.name }}
                                </span>
                            </div>
                        </div>
                        <span
                            v-if="
                                !filterDataDesignManagers ||
                                    filterDataDesignManagers.length === 0
                            "
                            class="text-body-2 grey--text"
                        >
                            —
                        </span>
                    </v-card>
                </template>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="4" sm="3" md="3" lg="2" xl="2" class="d-flex">
                <p class="mr-2 text-h6 text-bold">Total Stock:</p>
            </v-col>
            <v-col
                cols="8"
                sm="9"
                md="9"
                lg="10"
                xl="10"
                class="d-flex  flex-wrap"
            >
                <p class="text-body-1" :style="{ 'margin-top': '5px' }">
                    {{ formatCurrency('COP', totalStock, 0) }}
                </p>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="4" sm="3" md="3" lg="2" xl="2" class="d-flex">
                <p class="mr-2 text-h6 text-bold">Contract Price:</p>
            </v-col>
            <v-col
                cols="8"
                sm="9"
                md="9"
                lg="10"
                xl="10"
                class="d-flex  flex-wrap"
            >
                <p class="text-body-1" :style="{ 'margin-top': '5px' }">
                    {{ formatCurrency(project.currency, project.price, 2) }}
                </p>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="4" sm="3" md="3" lg="2" xl="2" class="d-flex">
                <p class="mr-2 text-h6 text-bold">Amount Billed:</p>
            </v-col>
            <v-col
                cols="8"
                sm="9"
                md="9"
                lg="10"
                xl="10"
                class="d-flex  flex-wrap"
            >
                <p class="text-body-1" :style="{ 'margin-top': '5px' }">
                    {{
                        formatCurrency(
                            project.currency,
                            project.totalInvoiced || 0,
                            2
                        )
                    }}
                    -
                    <strong
                        >{{
                            calculatePercentage(
                                project.totalInvoiced,
                                project.price
                            )
                        }}
                        %</strong
                    >
                </p>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="4" sm="3" md="3" lg="2" xl="2" class="d-flex">
                <p class="mr-2 text-h6 text-bold">Balance To Bill:</p>
            </v-col>
            <v-col
                cols="8"
                sm="9"
                md="9"
                lg="10"
                xl="10"
                class="d-flex  flex-wrap"
            >
                <p class="text-body-1" :style="{ 'margin-top': '5px' }">
                    {{
                        formatCurrency(
                            project.currency,
                            project.price - (project.totalInvoiced || 0),
                            2
                        )
                    }}
                    -
                    <strong
                        >{{
                            calculatePercentage(
                                project.price - project.totalInvoiced,
                                project.price
                            )
                        }}
                        %</strong
                    >
                </p>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="4" sm="3" md="3" lg="2" xl="2" class="d-flex">
                <p class="mr-2 text-h6 text-bold">Location:</p>
            </v-col>
            <v-col
                cols="8"
                sm="9"
                md="9"
                lg="10"
                xl="10"
                class="d-flex  flex-wrap"
            >
                <p class="text-body-1" :style="{ 'margin-top': '5px' }">
                    {{ project.city }} - {{ project.state }} -
                    {{ project.country }}
                </p>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="4" sm="3" md="3" lg="2" xl="2" class="d-flex">
                <p class="mr-2 text-h6 text-bold">Address:</p>
            </v-col>
            <v-col
                cols="8"
                sm="9"
                md="9"
                lg="10"
                xl="10"
                class="d-flex  flex-wrap"
            >
                <p class="text-body-1" style="margin-top: 5px">
                    {{ project.address ? project.address : '' }}
                </p>
            </v-col>
        </v-row>
        <v-row no-gutters v-if="localQuote">
            <v-col cols="4" sm="3" md="3" lg="2" xl="2" class="d-flex">
                <p class="mr-4 text-h6 text-bold">Follow up:</p>
            </v-col>
            <v-col
                cols="8"
                sm="9"
                md="9"
                lg="10"
                xl="10"
                class="d-flex  flex-wrap"
            >
                <v-autocomplete
                    v-model="localQuote"
                    :items="selectedQuotes"
                    flat
                    label="Quotes"
                    item-text="name"
                    return-object
                    class="mt-n3"
                    @change="changeQuoteToFollowUp"
                >
                </v-autocomplete>
            </v-col>
        </v-row>
        <v-row no-gutters v-if="project.archive">
            <v-col cols="4" sm="3" md="3" lg="2" xl="2" class="d-flex">
                <p class="mr-4 text-h6 text-bold">Exports Closed:</p>
            </v-col>
            <v-col
                cols="8"
                sm="9"
                md="9"
                lg="10"
                xl="10"
                class="d-flex  flex-wrap"
            >
                <span
                    class="py-0 mt-1"
                    :style="{
                        'font-size': '14px',
                        color: '#2b81d6',
                        'text-decoration': 'underline',
                        cursor: 'pointer',
                    }"
                    @click="openFile(project.exports)"
                    >{{ project.exports }}</span
                >
            </v-col>
        </v-row>
        <v-row no-gutters v-if="project.archive">
            <v-col cols="4" sm="3" md="3" lg="2" xl="2" class="d-flex">
                <p class="mr-4 text-h6 text-bold">
                    Portfolio Reconciled With The Client:
                </p>
            </v-col>
            <v-col
                cols="8"
                sm="9"
                md="9"
                lg="10"
                xl="10"
                class="d-flex  flex-wrap"
            >
                <span
                    class="py-0 mt-1"
                    :style="{
                        'font-size': '14px',
                        color: '#2b81d6',
                        'text-decoration': 'underline',
                        cursor: 'pointer',
                    }"
                    @click="openFile(project.clientPortfolio)"
                    >{{ project.clientPortfolio }}</span
                >
            </v-col>
        </v-row>
        <v-row no-gutters v-if="project.archive">
            <v-col cols="4" sm="3" md="3" lg="2" xl="2" class="d-flex">
                <p class="mr-4 text-h6 text-bold">Project Closed In SAP:</p>
            </v-col>
            <v-col
                cols="8"
                sm="9"
                md="9"
                lg="10"
                xl="10"
                class="d-flex  flex-wrap"
            >
                <span
                    class="py-0 mt-1"
                    :style="{
                        'font-size': '14px',
                        color: '#2b81d6',
                        'text-decoration': 'underline',
                        cursor: 'pointer',
                    }"
                    @click="openFile(project.closingInSAP)"
                    >{{ project.closingInSAP }}</span
                >
            </v-col>
        </v-row>
        <v-row no-gutters v-if="project.archive">
            <v-col cols="4" sm="3" md="3" lg="2" xl="2" class="d-flex">
                <p class="mr-4 text-h6 text-bold">
                    Removed From SharePoint:
                </p>
            </v-col>
            <v-col
                cols="8"
                sm="9"
                md="9"
                lg="10"
                xl="10"
                class="d-flex  flex-wrap"
            >
                <span
                    class="py-0 mt-1"
                    :style="{
                        'font-size': '14px',
                        color: '#2b81d6',
                        'text-decoration': 'underline',
                        cursor: 'pointer',
                    }"
                    @click="openFile(project.removedFromSharePoint)"
                    >{{ project.removedFromSharePoint }}</span
                >
            </v-col>
        </v-row>
        <v-row no-gutters v-if="project.archive">
            <v-col cols="4" sm="3" md="3" lg="2" xl="2" class="d-flex">
                <p class="mr-4 text-h6 text-bold">
                    Closing Meeting Completed:
                </p>
            </v-col>
            <v-col
                cols="8"
                sm="9"
                md="9"
                lg="10"
                xl="10"
                class="d-flex  flex-wrap"
            >
                <span
                    class="py-0 mt-1"
                    :style="{
                        'font-size': '14px',
                        color: '#2b81d6',
                        'text-decoration': 'underline',
                        cursor: 'pointer',
                    }"
                    @click="openFile(project.closingMeetingCompleted)"
                    >{{ project.closingMeetingCompleted }}</span
                >
            </v-col>
        </v-row>
        <!-- Assign purchase approver -->
        <v-dialog width="500px" v-model="assignApprover" persistent>
            <v-card :loading="loading">
                <v-card-title>Assign Purchase Approver</v-card-title>
                <v-card-text>
                    <v-combobox
                        v-model="newApproverUser"
                        :items="availableUsersForApprover"
                        item-text="name"
                        item-value="id"
                        label="Select the user"
                        clearable
                        single-line
                        hide-details="auto"
                        variant="outlined"
                        class="mb-4"
                    >
                    </v-combobox>
                    <v-text-field
                        v-model="newApproverLimit"
                        :label="`Approval Limit (${project?.currency || ''})`"
                        type="number"
                        :rules="[rules.validateNumber]"
                        hide-details="auto"
                        variant="outlined"
                    />
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="closeAssignDialog" color="grey">
                        Cancel</v-btn
                    >
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="addNewApprover"
                        color="primary"
                        :disabled="
                            loading ||
                                !newApproverUser ||
                                !newApproverLimit ||
                                newApproverLimit === ''
                        "
                        >Assign</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Edit/Delete purchase approver -->
        <v-dialog width="500px" v-model="editApproverDialog" persistent>
            <v-card :loading="loading">
                <v-card-title>Edit Purchase Approver</v-card-title>
                <v-card-text>
                    <div class="mb-4">
                        <div class="font-weight-bold mb-2">
                            {{ selectedApprover?.name }}
                        </div>
                        <v-text-field
                            v-model="editLimitApproval"
                            :label="
                                `Approval Limit (${project?.currency || ''})`
                            "
                            type="number"
                            :rules="[rules.validateNumber]"
                            hide-details="auto"
                            variant="outlined"
                        />
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        @click="deleteApprover"
                        color="error"
                        :disabled="loading"
                        >Delete</v-btn
                    >
                    <v-spacer></v-spacer>
                    <v-btn @click="closeEditDialog" color="grey">Cancel</v-btn>
                    <v-btn
                        @click="updateApprover"
                        color="primary"
                        :disabled="
                            loading ||
                                !editLimitApproval ||
                                editLimitApproval === ''
                        "
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { storage } from '@/services/firebase'
import API from '@/services/api'
import { openFile } from '@/services/storage/openFile.js'
import { mapMutations } from 'vuex'

export default {
    components: {},
    name: 'ProjectDetails',
    props: {
        project: Object,
        quotes: Array,
        users: Array,
        clients: Array,
    },
    data: () => ({
        selectedQuotes: [],
        localQuote: undefined,
        errorMsg: undefined,
        companyId: JSON.parse(localStorage.getItem('company')),
        clientImage: '',
        accountManagerImage: '',
        projectManagerImage: '',
        purchaseApproversImages: {},
        collaborators: [],
        designManagers: [],
        totalStock: 0,
        loading: false,
        assignApprover: false,
        assignPurchaseApproverPermission: false,
        editApproverDialog: false,
        selectedApprover: null,
        editLimitApproval: null,
        newApproverUser: null,
        newApproverLimit: null,
        rules: {
            validateNumber: v => {
                if (v === null || v === '') return 'Required'
                const numberValue = parseFloat(v)
                return (
                    (!isNaN(numberValue) && numberValue > 0) || 'Invalid number'
                )
            },
        },
    }),
    inject: {
        replaceQuoteToFollowUp: {
            from: 'replaceQuoteToFollowUp',
            default() {
                return null
            },
        },
    },
    computed: {
        filterDataColab() {
            return this.collaborators.filter(collaborator => {
                return (
                    collaborator.name !== this.project.projectManagerName &&
                    collaborator.name !== this.project.accountManagerName
                )
            })
        },
        filterDataDesignManagers() {
            return this.designManagers.filter(dm => dm && dm.name)
        },
        purchaseApproversList() {
            if (
                !this.project.purchaseApprovers ||
                typeof this.project.purchaseApprovers !== 'object'
            ) {
                return []
            }
            return Object.entries(this.project.purchaseApprovers).map(
                ([userId, limit]) => {
                    const user = this.users.find(u => u.id === userId)
                    return {
                        id: userId,
                        name: user ? user.name : '',
                        limit: limit,
                        image: this.purchaseApproversImages[userId] || '',
                    }
                }
            )
        },
        availableUsersForApprover() {
            if (!this.users || this.users.length === 0) {
                return []
            }
            if (
                !this.project.purchaseApprovers ||
                typeof this.project.purchaseApprovers !== 'object'
            ) {
                return this.users
            }
            const existingApproverIds = Object.keys(
                this.project.purchaseApprovers
            )
            return this.users.filter(
                user => !existingApproverIds.includes(user.id)
            )
        },
    },
    watch: {
        quotes() {
            this.setQuoteInfo()
        },
        'project.purchaseApprovers': {
            async handler(newVal) {
                if (newVal && typeof newVal === 'object') {
                    await this.$nextTick()
                    if (this.users && this.users.length > 0) {
                        await this.loadPurchaseApproversImages()
                    }
                } else {
                    this.$set(this, 'purchaseApproversImages', {})
                }
            },
            deep: true,
            immediate: false,
        },
        users: {
            async handler(newVal) {
                if (
                    newVal &&
                    newVal.length > 0 &&
                    this.project.purchaseApprovers &&
                    typeof this.project.purchaseApprovers === 'object'
                ) {
                    await this.loadPurchaseApproversImages()
                }
            },
        },
    },
    async mounted() {
        try {
            this.loading = true
            // load client image
            const client = this.clients.find(c => c.id === this.project.client)
            this.clientImage = ''
            if (client?.picture) {
                this.clientImage = await this.loadImage(
                    client.picture,
                    'clients_pictures'
                )
            }

            // load account manager image
            const aManager = this.users.find(
                c => c.id === this.project.accountManager
            )
            this.accountManagerImage = ''
            if (aManager?.picture) {
                this.accountManagerImage = await this.loadImage(
                    aManager.picture,
                    'users_pictures'
                )
            }

            // load project manager image
            const pManager = this.users.find(
                c => c.id === this.project.projectManager
            )
            this.projectManagerImage = ''
            if (pManager?.picture) {
                this.projectManagerImage = await this.loadImage(
                    pManager.picture,
                    'users_pictures'
                )
            }

            // load project purchase approvers images
            await this.loadPurchaseApproversImages()

            // load collaborators images
            for (let collaborator of this.project.collaborators) {
                const user = this.users.find(c => c.id === collaborator)
                if (user) {
                    collaborator = { name: user.name }
                    if (user?.picture) {
                        collaborator.picture = await this.loadImage(
                            user.picture,
                            'users_pictures'
                        )
                    }
                    this.collaborators.push(collaborator)
                }
            }

            // load design managers images
            for (let designManagerId of this.project.designManagers || []) {
                const user = this.users.find(c => c.id === designManagerId)
                if (user) {
                    let designManager = { name: user.name }
                    if (user?.picture) {
                        designManager.picture = await this.loadImage(
                            user.picture,
                            'users_pictures'
                        )
                    }
                    this.designManagers.push(designManager)
                }
            }

            const {
                data: { user },
            } = await API.getMyInfo()

            // set assign purchase approver permission
            this.assignPurchaseApproverPermission = user.permissions.includes(
                'assignPurchaseApprover'
            )

            if (this.quotes) {
                this.setQuoteInfo(this.quotes)
            } else {
                if (user.permissions.includes('readProjectQuotes')) {
                    const quotes = await API.getProjectQuotes(this.project.id)
                    this.setQuoteInfo(quotes)
                }
            }
            await this.getStock()
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        async loadPurchaseApproversImages() {
            try {
                this.$set(this, 'purchaseApproversImages', {})
                if (
                    !this.project.purchaseApprovers ||
                    typeof this.project.purchaseApprovers !== 'object'
                ) {
                    return
                }
                if (!this.users || this.users.length === 0) {
                    return
                }
                const userIds = Object.keys(this.project.purchaseApprovers)
                for (const userId of userIds) {
                    const purchaseApprover = this.users.find(
                        c => c.id === userId
                    )
                    if (purchaseApprover?.picture) {
                        const imageUrl = await this.loadImage(
                            purchaseApprover.picture,
                            'users_pictures'
                        )
                        this.$set(
                            this.purchaseApproversImages,
                            userId,
                            imageUrl
                        )
                    } else {
                        this.$set(this.purchaseApproversImages, userId, '')
                    }
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        async openFile(file) {
            try {
                this.loading = true
                await openFile(
                    file,
                    `${this.companyId}/projects/${this.project.id}/closing`
                )
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        formatCurrency(currency, price, digits) {
            return new Intl.NumberFormat('de-DE', {
                style: 'currency',
                currency: currency,
                currencyDisplay: 'code',
                maximumFractionDigits: digits,
            }).format(price)
        },
        getUserName(id) {
            if (this.users.length > 0) {
                const userReference = this.users.find(user => user.id == id)
                if (userReference) {
                    return userReference.name
                } else {
                    return ''
                }
            } else {
                return ''
            }
        },
        getClientName(id) {
            if (this.clients.length > 0) {
                const clientReference = this.clients.find(
                    client => client.id == id
                )
                if (clientReference) {
                    return clientReference.name
                } else {
                    return ''
                }
            } else {
                return ''
            }
        },
        getQuoteName(id) {
            const quoteId = id.split('/')[0]
            if (this.quotes.length > 0) {
                return this.quotes.find(quote => quote.id == quoteId).name
            } else {
                return ''
            }
        },
        async loadImage(picture, folder) {
            try {
                this.loading = true
                this.errorMsg = undefined
                const path = `${this.companyId}/${folder}`
                const storageRef = storage().ref(path)
                const profilePicRef = storageRef.child(picture)
                var url = ''
                await profilePicRef
                    .getDownloadURL()
                    .then(res => {
                        url = res
                    })
                    .catch(() => {
                        url = ''
                    })
                return url
            } catch (error) {
                this.errorMsg = error.message
                return ''
            } finally {
                this.loading = false
            }
        },
        changeQuoteToFollowUp(val) {
            this.replaceQuoteToFollowUp(val)
        },
        setQuoteInfo(quotes) {
            if (
                !Array.isArray(this.project?.quotes) ||
                !Array.isArray(quotes)
            ) {
                this.selectedQuotes = []
                this.localQuote = undefined
                this.replaceQuoteToFollowUp(null)
                return
            }

            this.selectedQuotes = this.project.quotes.map(quote => {
                return quotes.find(q => q?.id === quote.split('/')[0])
            })

            if (
                !this.project.quoteToFollowUp &&
                this.project.quotes.length > 0
            ) {
                this.project.quoteToFollowUp = this.project.quotes[0].split(
                    '/'
                )[0]
            }

            this.localQuote = quotes.find(quote => {
                return quote?.id === this.project.quoteToFollowUp
            })

            this.replaceQuoteToFollowUp(this.localQuote)
        },
        async getStock() {
            try {
                let items = []
                const stock = await API.getStock()
                for (const element of stock) {
                    element.items.forEach(item => {
                        if (
                            (item.order || item.orderNumber) &&
                            this.project.sapCode &&
                            (item.order || item.orderNumber) ==
                                this.project.sapCode
                        ) {
                            items.push(item)
                        }
                    })
                }
                items.forEach(item => {
                    item.usable_free_value = Number(item.usable_free_value)
                })
                this.totalStock = 0
                this.totalStock = items.reduce(
                    (accumulator, item) => accumulator + item.usable_free_value,
                    0
                )
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        calculatePercentage(value1, value2) {
            const partialValue = !isNaN(Number(value1)) ? Number(value1) : 0
            const totalValue = !isNaN(Number(value2)) ? Number(value2) : 0
            return totalValue > 0
                ? ((partialValue * 100) / totalValue).toFixed(2)
                : '0.00'
        },
        openEditApproverDialog(approver) {
            if (!this.assignPurchaseApproverPermission) {
                return
            }
            this.selectedApprover = approver
            this.editLimitApproval = approver.limit
            this.editApproverDialog = true
        },
        closeEditDialog() {
            this.editApproverDialog = false
            this.selectedApprover = null
            this.editLimitApproval = null
        },
        async updateApprover() {
            if (!this.assignPurchaseApproverPermission) {
                return
            }
            try {
                this.loading = true
                const purchaseApprovers = { ...this.project.purchaseApprovers }
                purchaseApprovers[this.selectedApprover.id] = Number(
                    this.editLimitApproval
                )

                await API.updatePuchaseApprover({
                    projectId: this.project.id,
                    purchaseApprovers: purchaseApprovers,
                })

                this.$set(this.project, 'purchaseApprovers', purchaseApprovers)

                this.closeEditDialog()
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        async deleteApprover() {
            if (!this.assignPurchaseApproverPermission) {
                return
            }
            try {
                this.loading = true
                const purchaseApprovers = { ...this.project.purchaseApprovers }
                delete purchaseApprovers[this.selectedApprover.id]

                await API.updatePuchaseApprover({
                    projectId: this.project.id,
                    purchaseApprovers: purchaseApprovers,
                })

                this.$set(this.project, 'purchaseApprovers', purchaseApprovers)

                this.closeEditDialog()
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        closeAssignDialog() {
            this.assignApprover = false
            this.newApproverUser = null
            this.newApproverLimit = null
        },
        async addNewApprover() {
            try {
                this.loading = true
                const userId =
                    typeof this.newApproverUser === 'object'
                        ? this.newApproverUser.id
                        : this.newApproverUser

                if (!userId) {
                    throw new Error('User is required')
                }

                const purchaseApprovers = {
                    ...(this.project.purchaseApprovers || {}),
                }
                purchaseApprovers[userId] = Number(this.newApproverLimit)

                await API.updatePuchaseApprover({
                    projectId: this.project.id,
                    purchaseApprovers: purchaseApprovers,
                })

                this.$set(this.project, 'purchaseApprovers', purchaseApprovers)

                this.closeAssignDialog()
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
    },
}
</script>

<style></style>
